// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Lz","pending":"e_Mz","slider":"e_Nz","imageContainer":"e_Oz","image":"e_Pz","button":"e_Qz","prevButton":"e_Rz","nextButton":"e_Sz","disabled":"e_Tz"};